module.exports = __webpack_public_path__ + "img/logo (1).e8aeec2c.png";